export const NOT_FOUND_PAGE_TITLE = 'Страница не найдена — Юрик.ру';

export const LEGAL_PAGE_TITLE = 'Правовые документы — Юрик.ру';
export const LEGAL_PAGE_DESCRIPTION =
  'Правовые документы сервиса Юрик.ру — пользовательское соглашение, политика конфиденциальности и другие документы';

export const CATALOG_PAGE_TITLE = 'Каталог юристов и адвокатов — Юрик.ру';
export const CATALOG_PAGE_DESCRIPTION =
  'Каталог проверенных юристов и адвокатов по всем отраслям права. Фильтры по городу, специализации, рейтингу и отзывам — Юрик.ру';

export const JOURNAL_PAGE_TITLE = 'Журнал — статьи и полезные материалы — Юрик.ру';
export const JOURNAL_PAGE_DESCRIPTION =
  'Юридический журнал Юрик.ру — полезные статьи, советы и разъяснения по правовым вопросам от квалифицированных юристов';

export const MAIN_PAGE_TITLE = 'Сервис по подбору юристов, адвокатов - Юрик.ру';
export const MAIN_PAGE_DESCRIPTION =
  'Юридическая помощь в вашем городе ⚖ Бесплатные онлайн консультации от квалифицированных юристов и адвокатов по любым вопросам - Юрик.ру';

export const FOR_LAYWERS_PAGE_TITLE =
  'Клиенты для юристов и адвокатов - Станьте проверенным юристом Юрик.ру';
export const FOR_LAYWERS_PAGE_DESCRIPTION =
  'Имеете квалификацию юриста или адвоката? Станьте проверенным юристом Юрик.ру и мы поможем Вам находить новых клиентов!';
